import { render, staticRenderFns } from "./TeamAdd.vue?vue&type=template&id=dd4c390a&scoped=true&"
import script from "./TeamAdd.vue?vue&type=script&lang=js&"
export * from "./TeamAdd.vue?vue&type=script&lang=js&"
import style0 from "./TeamAdd.vue?vue&type=style&index=0&id=dd4c390a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4c390a",
  null
  
)

export default component.exports